import { Injectable } from "@angular/core";
import { AppConfigService } from "./app-config.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Subscription } from "../models/subscription.model";
import { UserSubscription } from "../models/userSubscription.model";

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
    private baseApiUrl: string;
    private baseAuthenticatedApiUrl: string;

    constructor(
        private httpService: HttpClient,
        private readonly configService: AppConfigService
    ){
        this.baseApiUrl = this.configService.getConfig().baseApiUrl;
        this.baseAuthenticatedApiUrl = `${this.baseApiUrl}Auth/`;
    }

    getSubscriptions(): Promise<Array<Subscription>> {
        return new Promise((resolve, reject) => {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                })
            };

            this.httpService.get<Array<Subscription>>(`${this.baseApiUrl}Subscription/all`, httpOptions)
                .subscribe({
                    next: (result: Array<Subscription>) => {
                        resolve(result);
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    getActiveSubscription(token: string, userId: string): Promise<UserSubscription> {
        return new Promise((resolve, reject) => {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': token
                })
            };

            this.httpService.get<UserSubscription>(`${this.baseAuthenticatedApiUrl}Subscription/${userId}`, httpOptions)
                .subscribe({
                    next: (result: UserSubscription) => {
                        resolve(result);
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}